import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import useMetersTable from "../../useMetersTable.js";
import Button from "components/CustomButtons/Button.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import AddUserDialog from "./AddMeterDialog.js";
import EditUserDialog from "./EditMeterDialog";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { makeStyles, withStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import CloseIcon from "@mui/icons-material/Close";
import { compte } from "variables/patrimoine.js";
import Edit from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import {updateAccountMeter,getAccountContracts,getAccountDsos,getAPIAuthorizationList} from "services/ConfigServices.js";
import { utilitytypebyenergy} from "variables/lists/authorization";

const useStyles = makeStyles(styles);

const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
});

const useStyles2 = makeStyles((theme) => ({
  root: {
    margin: "0 0 0 -8px",
    "& > *": {
      margin: '8px',
    },
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
  chip: {
    margin: '4px',
  },
}));

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;


const ExpandableComponent = props => {
  const { data, energy, parameters, dsoData, utilitiesData } = props;
  const [value, setValue] = useState(0);

  const classes = useStyles2();

  function handleSubMenuChange(value) {
    setValue(value);
  }

  const SubTabs = () => {

    return (
      <>
        <div>

          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].address} : </ElementTitle>
            <ElementData>{data.details?.localization?.description}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].serialnumber} : </ElementTitle>
            <ElementData>{data.details?.serialnumber}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].dso} : </ElementTitle>
            <ElementData>{dsoData.find((x) => x.id == data.details?.dso)?.name}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].associatedcontractid} : </ElementTitle>
            <ElementData>{utilitiesData.find((x) => x.id == data.details?.associatedcontractid)?.name}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].monthlyconsumption} : </ElementTitle>
            <ElementData>{data.details?.monthlyconsumption === true ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].dailyconsumption} : </ElementTitle>
            <ElementData>{data.details?.dailyconsumption === true ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].loadcurve} : </ElementTitle>
            <ElementData>{data.details?.loadcurve === true ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].contractualdata} : </ElementTitle>
            <ElementData>{data.details?.contractualdata === true ? 'Oui' : 'Non'}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].associatedfiles} : </ElementTitle>
            <ElementData>{data.details?.associatedfiles}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].comments} : </ElementTitle>
            <ElementData>{data.details?.comments}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].description} : </ElementTitle>
            <ElementData>{data.details?.description}</ElementData>
          </ExpandableElement>
          <ExpandableElement>
            <ElementTitle>{compte.energy[energy][parameters].usagecode} : </ElementTitle>
            <ElementData>{data.details?.usagecode}</ElementData>
          </ExpandableElement>
        </div>

      </>
    );
  };

  return (
    <Container>
      <ExpandableContainer>
        <div>
          <SubTabs />
        </div>
      </ExpandableContainer>
    </Container>
  );
};

const Meters = (props) => {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const { energy, parameters } = props;
  const {
    gridState,
    error,
    refetch,
    invalidate,
    handleClose,
    setMeters,
  } = useMetersTable(
    energy,
    parameters,
    <AddUserDialog
      energy={energy}
      parameters={parameters}
      closeModal={() => handleClose()}
      refetch={() => refetch()}
      deleteCounter={() => handleDeleteCounterChange()}
    />,
    "Nouveau compteur",
    "Ajout d'un compteur",
    "Liste compteurs"
  );
  const [deleteCounter, setDeleteCounter] = useState(0);

  const [open, setOpen] = useState(false);

  const [editedMeter, setEditedMeter] = useState(null);
  const [utilityauthorizationData, setUtilityauthorizationData] = useState([]);
  const [authorizationData, setAuthorizationData] = useState([]);
  const [utilitiesData, setUtilitiesData] = useState([]);
  const [dsoData, setDsoData] = useState([]);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handleDeleteCounterChange = (e) => {
    setDeleteCounter((prevCounter) => prevCounter + 1);
  };
  
  const classes = useStyles();

  let dataUsers = gridState.data;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const columns = [
    {
      name: compte.energy[energy][parameters].key,
      selector: row => row.details?.clef,
      sortable: true,
      maxWidth: "12rem",
    },
    {
      name: compte.energy[energy][parameters].meternumber,
      selector: row => row.meternumber,
      sortable: true, 
      maxWidth: "12rem",
      cell: (row) => row.meternumber
    },
    {
      name: compte.energy[energy][parameters].status,
      selector: row => row.details?.status,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => (
        <>
          <div className="actions-right">{row.details?.status === "on" ? 'Actif' : "Résilié"}</div>
        </>
      ),
    },
    {
      name: compte.energy[energy][parameters].acheminement,
      selector: row => row.details?.acheminement,
      sortable: true,
      maxWidth: "10rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">{row.details?.dso}</div>
        </>
      ),
    },
    {
      name: compte.energy[energy][parameters].name,
      selector: row => row.details?.name,
      sortable: true,
      //maxWidth: "40rem",
      cell: (row) => row.details?.name
    },
    {
      name: compte.energy[energy][parameters].description,
      selector: row => row.details?.description,
      sortable: true,
      //maxWidth: "40rem",
      cell: (row) => row.details?.description
    },
    realestateupdate ?
      {
        name: "Actions",
        sortable: true,
        width: "8rem",
        // eslint-disable-next-line react/display-name
        cell: (row) => (
          <>
            <div className="actions-right">
              <Button
                color={"success"}
                className={classes.actionButton}
                onClick={editUser(row)}
              >
                <Edit className={classes.icon} />
              </Button>
              <CustomDeleteButton
                deleteTitle={"Suppression du compteur"}
                deleteSubTitle={
                  "Êtes-vous sûr de vouloir supprimer le compteur ?"
                }
                handleSupprimer={deleteMeter(row)}
              />
            </div>
          </>
        ),
      } : {},
  ];

  useEffect(() => {
    axios
    .get(
      getAPIAuthorizationList(chartIdGroup),
      {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
    .then((res) => {
      let tmpAuthorizationData = res.data.authorizations?.filter((data) => data.energy === energy).map((data) => {
        return (
          { name: data.legalname + " (" + data.dateend + ")", id: data.id }
        );
      });
      setAuthorizationData(
        tmpAuthorizationData || []
      );
      let tmpUtilityauthorizationData = res.data.authorizations?.filter((data) => (data.energy === energy || data.energy ==='multiple') && utilitytypebyenergy[energy].includes(data.type)).map((data) => {
        return (
          { name: data.legalname + " (" + data.dateend + ")", id: data.id }
        );
      });
      setUtilityauthorizationData(
        tmpUtilityauthorizationData || []
      );
    });
  }, []);

  useEffect(() => {
    axios
      .get(
        getAccountContracts(chartIdGroup, energy),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpUtilitiesData = res.data.contracts?.map((data) => {
          return (
            { name: data.details.contractnumber + " (" + data.details.name + ")", id: data.uuid }
          );
        });
        setUtilitiesData(tmpUtilitiesData);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getAccountDsos(chartIdGroup, energy),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpDsoData = res.data.dsos?.map((data) => {
          return (
            { name: data.details.name, id: data.uuid }
          );
        });
        setDsoData(tmpDsoData);
      });
  }, []);
  
  const [idSelected, setIdSelected] = useState();

  const editUser = (row) => async () => {
    let obj = dataUsers.find((o) => o.uuid === row.uuid);
    setEditedMeter(obj);
    handleClickOpen();
  };

  const deleteMeter = (row) => async () => {

    axios
      .delete(
        updateAccountMeter(row.uuid, chartIdGroup, energy),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then(() => {
        refetch();
      })
      .catch(() => { });
  };

  const handleSelectedRowsChange = (selection) => {
    setMeters(selection.selectedRows);
  };

  return (
    <>
      <div
        style={{
          marginTop: "-1.8rem ",
          paddingTop: "0.5rem",
          //borderTop: "solid 1.2px rgba(0, 0, 0, 0.15)",
        }}
      >
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          columns={columns}
          persistTableHead
          pagination
          noHeader={true}
          subHeader
          onSelectedRowsChange={handleSelectedRowsChange}
          selectableRows={true}
          expandOnRowClicked
          expandableRows
          expandableRowDisabled={(row) => row.disabled}
          expandableRowsComponent={ExpandableComponent}
          expandableRowsComponentProps={{energy,parameters, dsoData, utilitiesData }}
          progressPending={gridState.loading}
          progressComponent={<LinearProgress />}
          {...gridState}
        ></DataTable>
        <Dialog
          onClose={handleEditClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={open}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleEditClose}>
            Modifier le compteur
          </DialogTitle>
          <DialogContent dividers>
            <EditUserDialog
              energy={energy}
              parameters={parameters}
              closeModal={handleEditClose}
              refetch={refetch}
              meter={editedMeter}
              dsoData={dsoData}
              utilitiesData={utilitiesData}
              authorizationData={authorizationData}
              utilityauthorizationData={utilityauthorizationData}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default Meters;
